<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import InlineInput from 'dashboard/components-next/inline-input/InlineInput.vue';

const props = defineProps({
  hasErrors: { type: Boolean, default: false },
});

const title = defineModel('title', { type: String, default: '' });

const { t } = useI18n();

const inputClass = computed(() => {
  return props.hasErrors
    ? 'placeholder:!text-n-ruby-9 dark:placeholder:!text-n-ruby-9'
    : '';
});

const placeholder = computed(() =>
  t('COMPOSE_NEW_CONVERSATION.FORM.TITLE.PLACEHOLDER')
);
</script>

<template>
  <div class="flex items-baseline flex-1 w-full gap-3 px-4 pt-4 pb-3">
    <InlineInput
      v-model="title"
      :placeholder="placeholder"
      :label="t('COMPOSE_NEW_CONVERSATION.FORM.TITLE.LABEL')"
      :custom-input-class="inputClass"
    />
  </div>
</template>
